import React from 'react';

const PatientProfile = ({ patient }) => {
  return (
    <section className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-lg mx-auto mt-8">
      <h2 className="text-3xl font-bold text-primary mb-6">{patient.name}</h2>

      <ul className="space-y-4 text-lg">
        <li className="text-gray-700 dark:text-gray-300">
          <span className="font-semibold">Idade:</span> {patient.age} anos
        </li>
        <li className="text-gray-700 dark:text-gray-300">
          <span className="font-semibold">CPF:</span> {patient.cpf}
        </li>
        <li className="text-gray-700 dark:text-gray-300">
          <span className="font-semibold">Número SUS:</span> {patient.susNumber}
        </li>
        <li className="text-gray-700 dark:text-gray-300">
          <span className="font-semibold">Data de Nascimento:</span>{' '}
          {patient.birthDate}
        </li>
        <li className="text-gray-700 dark:text-gray-300">
          <span className="font-semibold">Endereço:</span> {patient.address}
        </li>
        <li className="text-gray-700 dark:text-gray-300">
          <span className="font-semibold">Alergias:</span>{' '}
          {patient.allergies || 'Nenhuma'}
        </li>
        <li className="text-gray-700 dark:text-gray-300">
          <span className="font-semibold">Condições Crônicas:</span>{' '}
          {patient.chronicConditions || 'Nenhuma'}
        </li>
      </ul>

      <button
        className="mt-6 w-full bg-primary text-white py-3 rounded-md transition hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
        aria-label={`Ver detalhes do paciente ${patient.name}`}
      >
        Ver Detalhes
      </button>
    </section>
  );
};

export default PatientProfile;
